"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Mail = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: 16,
  height: 12,
  viewBox: "0 0 16 12"
}, props), _react.default.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, _react.default.createElement("path", {
  d: "M0-2h16v16H0z"
}), _react.default.createElement("path", {
  className: "fill",
  d: "M15.907 1.542a.738.738 0 0 0-.051.033L8 6.341.144 1.575a.738.738 0 0 0-.051-.033A2.186 2.186 0 0 1 2.182 0h11.636c.983 0 1.818.652 2.09 1.542zM16 3.18v6.653C16 11.027 15.02 12 13.818 12H2.182A2.179 2.179 0 0 1 0 9.833V3.18l7.583 4.634c.25.174.584.174.834 0L16 3.18z"
})));

var _default = Mail;
exports.default = _default;